<template>
  <!-- copy of home -->
  <div
    class="pt-12 pb-20 xl:py-16"
    style="background: linear-gradient(90deg, #2F2F2F 0%, #151515 100%);"
  >
    <div class="container xl:flex xl:items-center xl:justify-between">
      <div>
        <div class="text-center text-white text-2xl xl:text-left xl:text-4xl">
          Join the all-in-one video and <br />
          filmmakers platform today.
        </div>

        <p class="mt-2 text-center text-white text-lg xl:text-left">
          {{ data.subtitle }}
        </p>
      </div>

      <div class="mt-6 mx-auto max-w-screen-md flex space-x-4 xl:mr-0">
        <a
          :href="$store.getters.isLoggedIn ? '/account' : '/pricing'"
          class="w-1/2 ma-btn ma-btn--blue xl:w-32"
          @click="openSignUpModal"
        >
          Join Free
        </a>

        <a
          :href="$store.getters.paidUser ? '/account/upgrade' : '/pricing'"
          class="w-1/2 ma-btn ma-btn--o border-white text-white hover:bg-white hover:text-ma-black-0 xl:w-32"
        >
          View Pricing
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data"],
  methods: {
    openSignUpModal(e) {
      if (!this.$store.getters.isLoggedIn) {
        e.preventDefault()
        $store.dispatch('setOpenSignUpModal', { open: true, clickSource: 'sign up page', buttonName: 'Join Free' })
      }
    }
  }
};
</script>

<style scoped>
.bg-gradient {
  background: linear-gradient(270deg, #151515 0%, #2f2f2f 100%);
}
</style>
